var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarnIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 2.8999L1.93994 19.9999H22.0599L11.9999 2.8999ZM11.9999 5.8499L19.4399 18.4999H4.55994L11.9999 5.8499ZM11.0601 9.07007L11.3301 14.9201H12.6701L12.9301 9.07007H11.0601ZM11.0601 16.6001C11.0601 17.2201 11.3601 17.4601 12.0301 17.4601C12.7201 17.4601 13.0001 17.1501 13.0001 16.6001C13.0001 16.0501 12.7001 15.7301 12.0301 15.7301C11.3601 15.7301 11.0601 16.0501 11.0601 16.6001Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarnIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Warn_Icon.0f64a27b922aa26956099dfebda8311b.svg";